<ng-template><div class="mat-autocomplete-panel" role="listbox" [id]="id" [ngClass]="_classList" #panel><ng-content></ng-content></div></ng-template>


// WEBPACK FOOTER //
// ./node_modules/@angular/material/autocomplete/typings/index.d.ts.MatAutocomplete.html